import { render, staticRenderFns } from "./Vtex.vue?vue&type=template&id=1516e1bd&scoped=true&"
import script from "./Vtex.vue?vue&type=script&lang=js&"
export * from "./Vtex.vue?vue&type=script&lang=js&"
import style0 from "./Vtex.vue?vue&type=style&index=0&id=1516e1bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516e1bd",
  null
  
)

export default component.exports